import React, { useState, useEffect } from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import Summary from './Summary';
// import AccordionContainer from './AccordionContainer';
import ComplementoRow from '../../NewProdutoSimples/AcordeaoComplementos/ComplementoRow';

import api from '../../../../../../../services/api';
import { useRegisterAdded } from '../../../../../../../hooks/registerAdded';

import { AccordionWrapper } from '../../../drawer_styles';

interface ComplementoType {
  id: number;
  empresa_id: number;
  descricao: string;
  qtd_min: number;
  qtd_max: number;
  complemento_obrigatorio: boolean;
  tipo: number;
  imagem?: File;
  ativo: boolean;
  ordem: number;
}

interface ItemComplementoType {
  id: number;
  complemento_id: number;
  produto_id: number;
  codigo_complemento: number;
  descricao: string;
  imagem?: File;
  preco: number;
  ordem: number;
}

interface AcordeaoProps {
  complementos: ComplementoType[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    accordionItem: {
      borderTopLeftRadius: '0 !important',
      borderTopRightRadius: '0 !important',
      margin: '0 !important',
    },
    accordionDetails: {
      display: 'block',
      paddingTop: '0',
    },
  }),
);

const Acordeao: React.FC<AcordeaoProps> = ({ complementos }) => {
  const [itensComplemento, setItensComplemento] = useState<
    ItemComplementoType[]
  >([]);

  const classes = useStyles();
  const {
    hasComplementoUpdated,
    handleSetComplementoUpdated,
  } = useRegisterAdded();

  useEffect(() => {
    async function loadItensComplemento(): Promise<void> {
      const request = async (): Promise<void> => {
        const itensFinded: ItemComplementoType[] = [];

        await Promise.all(
          complementos.map(async (item) => {
            const response = await api.post(`/complemento/item/${item.id}`);
            itensFinded.push(...response.data);
          }),
        );

        setItensComplemento([...itensFinded]);
      };

      await request();

      if (hasComplementoUpdated) {
        await request();
        handleSetComplementoUpdated(false);
      }
    }

    loadItensComplemento();
  }, [complementos, hasComplementoUpdated, handleSetComplementoUpdated]);

  return (
    <>
      {complementos
        .sort((a, b) => a.ordem - b.ordem)
        .map((item) => (
          <AccordionWrapper>
            <div className={classes.root}>
              <Accordion className={classes.accordionItem} expanded>
                <Summary
                  id_complemento={item.id}
                  title={item.descricao}
                  isObrigatorio={item.complemento_obrigatorio}
                  complemento={item}
                />

                <AccordionDetails className={classes.accordionDetails}>
                  {itensComplemento.length > 0 && (
                    <>
                      {itensComplemento
                        .sort((a, b) => a.ordem - b.ordem)
                        .map((item_complemento) => (
                          <>
                            {item_complemento.complemento_id === item.id && (
                              <ComplementoRow
                                descricao={item_complemento.descricao}
                                preco={item_complemento.preco.toString()}
                              />
                            )}
                          </>
                        ))}
                    </>
                  )}
                </AccordionDetails>
              </Accordion>
            </div>
          </AccordionWrapper>
        ))}
    </>
  );
};

export default Acordeao;
